export const prefetchResources = (urls, eagerness = "eager") => {
    try {
        // Normalize to array if a single URL is passed
        const urlList = Array.isArray(urls) ? urls : [urls];

        if (
            HTMLScriptElement.supports && HTMLScriptElement.supports("speculationrules")
        ) {
            const specScript = document.createElement("script");
            specScript.type = "speculationrules";
            const specRules = {
                prefetch: [{
                    source: "list",
                    urls: urlList,
                    eagerness
                }]
            };
            specScript.textContent = JSON.stringify(specRules);
            document.body.append(specScript);
        } else {
            urlList.forEach((url) => {
                const linkElem = document.createElement("link");
                linkElem.rel = "prefetch";
                linkElem.href = url;
                document.head.append(linkElem);
            });
        }
    } catch (err) {
        console.warn("Unable to prefetch resources:", err);
    }
};
